export default {
  "ENTER": 13,
  "ESCAPE": 27,
  "LEFT": 37,
  "RIGHT": 39,
  "SPACEBAR": 32,
  "TAB": 9
}
